import { assert_string_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO__image_asset } from '../+image/image_asset_base/DTO__image_asset';
import { ENUM__workspace_entity } from '../+workspace/workspace_entity/_enums/ENUM__workspace_entity';

export class DTO__grid2d_cell extends DTO__database_entity {
  static _class_name_static: string = ENUM__dto_class_name.GRID2D_CELL;

  /*
   * DB FIELDS
   */

  grid2d_id!: string;
  grid2d_type!: string;
  grid2d_chunk_id!: string;

  hash_sha256_content!: string;

  image!: DTO__image_asset;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.hash_sha256_content = ENUM__string_id_empty.HASH_SHA256;

    this.image = DTO__image_asset.CREATE_STUB();
  }

  assert_standard_fields(): void {
    //avoid to call super.assert_standard_fields() because we can send to client data without id

    assert_type_enum(this.grid2d_type, ENUM__workspace_entity);
    assert_string_not_empty(this.grid2d_chunk_id);
  }

  masonry_grid__get_cell_width(max_side: number): number {
    if (this.image.is_stub()) return max_side;

    const { width, height } = this.image.image_size;

    const aspect_ratio: number = Number((width > height ? width / height : height / width).toFixed(2));

    if (width <= 0 || height <= 0) return max_side;

    // If the image is landscape (wider than it is tall),
    // scale the width relative to the max_side height.
    if (width > height) return Math.round((max_side * width) / height);

    // If it's portrait, scale it down based on the aspect ratio,
    // otherwise return max_side for square images.
    let out = height > width ? Math.round(max_side / aspect_ratio) : max_side;

    return out;
  }

  masonry_grid__get_cell_height(max_side: number): number {
    if (this.image.is_stub()) return max_side;

    const { width, height } = this.image.image_size;

    const aspect_ratio: number = Number((width > height ? width / height : height / width).toFixed(2));

    if (width <= 0 || height <= 0) return max_side;

    if (width < height) return Math.round((max_side * height) / width);

    let out = width > height ? Math.round(max_side / aspect_ratio) : max_side;

    return out;
  }

  toString(): string {
    return `${this._id}-${this.hash_sha256_content}`;
  }
}
